<template>
    <button class="swj-category-item" @click="$emit('click')">
        <Icon class="faq-category-icon" scale="1.5" :name="iconSrc" v-if="isIcon"/>
        <img class="faq-category-icon" :src="iconSrc" v-else/>
        {{ name }}
    </button>
</template>

<script>
    export default {
        name: "Category",
        props: {
            iconSrc: {
                type: String
            },
            isIcon: {
                type: Boolean,
                default: false
            },
            name: String
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../scss/color_palette";

    .faq-category-icon {
        height: 25px;
        margin-right: 10px;
        color: blue("100");
    }

    .swj-category-item {
        width: 100%;
        text-align: left;
        background: blue("10");
        border-radius: 9px;
        border: none;
        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none; /* IE10+ */
        padding: 15px;
        color: blue("100");
        font-weight: 600;
        outline: none;
    }
</style>